"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.view.title': 'Onboarding Dipendente',
    'onboarding.view.meet': 'Incontra',
    'onboarding.view.new_employee': 'Il Tuo Nuovo Dipendente IA',
    'onboarding.view.description.1': 'Con',
    'onboarding.view.description.2': 'creare e pubblicare contenuti è un gioco da ragazzi.',
    'onboarding.view.description.3': 'In pochi minuti,',
    'onboarding.view.description.4': 'crea una strategia di contenuti e tutti i contenuti per i prossimi mesi.',
    'onboarding.view.has_info': 'ha le seguenti informazioni:',
    'onboarding.view.step': 'Passo',
    'onboarding.view.step1_info': 'Nome, Età, Genere, Voce, Foto',
    'onboarding.view.knowledge': 'Conoscenza',
    'onboarding.view.learning_description': 'imparerà tutto sulla tua azienda scansionando il tuo sito web, i social media e altre informazioni fornite.',
    'onboarding.view.learning_description2': '',
    'onboarding.view.talk_with': 'Parla con',
};
